import useGrubhubGetRestaurantDetail from '@/lib/food-grubhub/hooks/useGrubhubGetRestaurantDetail'
import useGrubhubValidToken from '@/lib/food-grubhub/hooks/useGrubhubValidToken'
import {useGrubhubUserAddress} from '@/lib/food-grubhub/store'

import style from './FoodOrders.module.scss'

interface RestaurantInfoHookProps {
  readonly restaurantId: string | undefined
}

export function useRestaurantInfo({restaurantId}: RestaurantInfoHookProps) {
  const [storageUserLocation] = useGrubhubUserAddress()
  const storageToken = useGrubhubValidToken()

  const restaurantDetailQuery = {
    restaurantId: restaurantId ?? '',
    hideChoiceCategories: true,
    version: 4,
    variationId: 'rtpFreeItems',
    orderType: '',
    hideUnavailableMenuItems: false,
    hideMenuItems: false,
    locationMode: 'delivery',
    location: `POINT(${storageUserLocation.longitude ?? 0} ${storageUserLocation.latitude ?? 0})`,
  }

  const {
    data: restaurantDetail,
    isLoading: isRestaurantLoading,
    error: restaurantError,
  } = useGrubhubGetRestaurantDetail(restaurantDetailQuery, storageToken)

  const renderRestaurantInfo = () => {
    if (restaurantError || isRestaurantLoading || !restaurantDetail) {
      return <span className={style.LoadingText}>Loading restaurant...</span>
    }

    return (
      <div className={style.RestaurantContainer}>
        {restaurantDetail.restaurant.logo && (
          <img
            src={restaurantDetail.restaurant.logo}
            alt='Restaurant logo'
            className={style.RestaurantLogo}
          />
        )}
        <span className={style.RestaurantName}>
          {restaurantDetail.restaurant.name ?? 'Restaurant Name'}
        </span>
      </div>
    )
  }

  const renderRestaurantInfoDetails = () => {
    if (restaurantError || isRestaurantLoading || !restaurantDetail) {
      return <div className={style.LoadingText}>Loading restaurant...</div>
    }

    return (
      <>
        {restaurantDetail.restaurant.logo && (
          <img
            src={restaurantDetail.restaurant.logo}
            alt='Restaurant logo'
            className={style.RestaurantLogo}
          />
        )}
        <div className={style.RestaurantInfo}>
          <div className={style.RestaurantName}>
            {restaurantDetail.restaurant.name ?? 'Loading restaurant...'}
          </div>
        </div>
      </>
    )
  }

  const renderFoodImage = (menuItemId: string, itemName: string) => {
    if (restaurantError || isRestaurantLoading || !restaurantDetail) {
      return <div className={style.ImagePlaceholder}>🍽️</div>
    }

    const menuItem = (restaurantDetail.restaurant.menu_category_list ?? [])
      .flatMap(category => category.menu_item_list ?? [])
      .find(item => item.id === menuItemId)

    if (!menuItem?.media_image) {
      return <div className={style.ImagePlaceholder}>🍽️</div>
    }

    const itemImageUrl = `${menuItem.media_image.base_url}${menuItem.media_image.public_id}.${menuItem.media_image.format}`

    return <img src={itemImageUrl} alt={itemName} className={style.ItemImage} />
  }

  return {
    renderRestaurantInfo,
    renderRestaurantInfoDetails,
    renderFoodImage,
  }
}
